/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkspaceMindmapNodeType'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkspaceMindmapNodeType'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkspaceMindmapNodeTypeApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkspaceMindmapNodeType);
  }
}(this, function(ApiClient, WorkspaceMindmapNodeType) {
  'use strict';

  /**
   * WorkspaceMindmapNodeType service.
   * @module api/WorkspaceMindmapNodeTypeApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkspaceMindmapNodeTypeApi. 
   * @alias module:api/WorkspaceMindmapNodeTypeApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workspaceMindmapNodeTypeAddAllPut operation.
     * @callback module:api/WorkspaceMindmapNodeTypeApi~workspaceMindmapNodeTypeAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkspaceMindmapNodeType>} body 
     * @param {module:api/WorkspaceMindmapNodeTypeApi~workspaceMindmapNodeTypeAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.workspaceMindmapNodeTypeAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeTypeAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapNodeTypeAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/WorkspaceMindmapNodeType/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapNodeTypeDeleteAllPut operation.
     * @callback module:api/WorkspaceMindmapNodeTypeApi~workspaceMindmapNodeTypeDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/WorkspaceMindmapNodeTypeApi~workspaceMindmapNodeTypeDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workspaceMindmapNodeTypeDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeTypeDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapNodeTypeDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkspaceMindmapNodeType/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapNodeTypeEditAllPut operation.
     * @callback module:api/WorkspaceMindmapNodeTypeApi~workspaceMindmapNodeTypeEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkspaceMindmapNodeType>} body 
     * @param {module:api/WorkspaceMindmapNodeTypeApi~workspaceMindmapNodeTypeEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workspaceMindmapNodeTypeEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeTypeEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapNodeTypeEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkspaceMindmapNodeType/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapNodeTypeLoadMindmapNodeTypesGet operation.
     * @callback module:api/WorkspaceMindmapNodeTypeApi~workspaceMindmapNodeTypeLoadMindmapNodeTypesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkspaceMindmapNodeType>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadMindmapNodeTypes
     * @param {String} _4SAPIAppID 
     * @param {Integer} mindmapID 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.translate  (default to false)
     * @param {module:api/WorkspaceMindmapNodeTypeApi~workspaceMindmapNodeTypeLoadMindmapNodeTypesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkspaceMindmapNodeType>}
     */
    this.workspaceMindmapNodeTypeLoadMindmapNodeTypesGet = function(_4SAPIAppID, mindmapID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeTypeLoadMindmapNodeTypesGet";
      }

      // verify the required parameter 'mindmapID' is set
      if (mindmapID == undefined || mindmapID == null) {
        throw "Missing the required parameter 'mindmapID' when calling workspaceMindmapNodeTypeLoadMindmapNodeTypesGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'mindmapID': mindmapID,
        'translate': opts['translate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkspaceMindmapNodeType];

      return this.apiClient.callApi(
        '/WorkspaceMindmapNodeType/loadMindmapNodeTypes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
